module.exports = __webpack_public_path__ + "static/media/saas2.c3a6511a.png";